import axios from "axios";

const username = process.env.REACT_APP_BASIC_AUTH_USERNAME;
const password = process.env.REACT_APP_BASIC_AUTH_PASSWORD;
const credentials = window.btoa(`${username}:${password}`);

export const xhr = axios.create({
  withCredentials: true,
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json",
    Authorization: `Basic ${credentials}`,
  },
  baseURL:
    process.env.NODE_ENV === "development"
      ? "http://localhost:5005/api/economus"
      : "https://kabiti-apis-a3c65789f9b2.herokuapp.com/api/economus",
});

export const sendMessage = async (
  to: string,
  subject: string,
  data: Record<string, any>
) => {
  return await xhr.post("/send-message", { to, subject, variables: data });
};

export const getGalleryMedia = async () => {
  const response = await xhr.get("/gallery?withGroupName=true");
  return response.data.data;
};

export const getTranslationsByLang = async (lng: string) => {
  const response = await xhr.get(`/translation/${lng}`);
  return response.data;
};
